import { createSelector } from "reselect";
import columns from "../../../../../../react-table/helpers/columns";
import {
  summaryColumns,
  weekColumns,
} from "../../../common/redux/selectors/DespatchPerformanceMetadataMapper";
import ReportDefinitions from "../../../../../../common/config/ReportDefinitions";

export const getData =
  ReportDefinitions.IMPC_TO_IMPC_DESPATCH_PERFORMANCE.getDataFunction();
const getMetadata = (state) =>
  state.reporting.IMPC_TO_IMPC_DESPATCH_PERFORMANCE.metadata;
export const getIsLoading = (state) =>
  state.reporting.IMPC_TO_IMPC_DESPATCH_PERFORMANCE.isLoading;
export const getGeneratedOnDateTime = (state) =>
  getMetadata(state) && getMetadata(state).generatedOnDateTime;

export const getColumns = createSelector(
  getMetadata,
  getData,
  (metadata, data) => {
    if (!metadata || !metadata.weeks) {
      return [];
    }
    const { TextColumn } = columns(data);
    const weekColumnsFlat = weekColumns(metadata.weeks, data)?.flat();

    return [
      new TextColumn("Origin OE", "originImpc").withTotalHeader("Total"),
      new TextColumn("Destination OE", "destinationImpc"),
      ...summaryColumns(metadata.weeks, data),
      ...weekColumnsFlat,
    ];
  }
);
